import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { AddAddressComponent } from 'src/app/masters/add-address/add-address.component';
import { AddContactComponent } from './../../../masters/add-contact/add-contact.component';
import { AddDepartmentComponent } from './../../../masters/add-department/add-department.component';
import { Component, OnInit, Input, ViewChild ,ViewChildren,QueryList} from '@angular/core';
import { HospitalModel } from '../hospital.model';
import { OrganismModel } from '../../organisms/organism.model';
import { MasterService } from 'src/app/masters/master.service';
import { HospitalService } from '../hospitals.service';
import swal from 'sweetalert2';
import * as CommonConstants from '../../../utils/common.constants';
import { AddSpecialityComponent } from 'src/app/masters/add-speciality/add-speciality.component';
import { AddSubSpecialityComponent } from 'src/app/masters/add-sub-speciality/add-sub-speciality.component';
import { AddHyperSpecialityComponent } from 'src/app/masters/add-hyper-speciality/add-hyper-speciality.component';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from 'src/app/common/loader.service';
import { IntlTelNumberComponent } from 'src/app/common/intl-tel-number/intl-tel-number.component';
import { SharedService } from 'src/app/utils/shared.service';
import {CountryISO } from 'ngx-intl-tel-input';
@Component({
  selector: 'app-add-hospital',
  templateUrl: './add-hospital.component.html',
  styleUrls: ['./add-hospital.component.scss']
})
export class AddHospitalComponent implements OnInit {
  hospital: HospitalModel = new HospitalModel();
  organisms: OrganismModel[];
  towns: any[];
  hosp: HospitalModel = new HospitalModel();
  hospitalForm: FormGroup;
  legalForms:any[];
  addressTypeList: any;
  hyperSpecialities: any;
  subSpecialities: any;
  specialities: any;
  departments: any;
  countries: any;
  CountryISO = CountryISO;
  constructor(private masterService: MasterService, private hospitalService: HospitalService, private formBuilder: FormBuilder,
    private toastrService:ToastrService, private loaderService : LoaderService,private sharedService : SharedService) 
  { 
    this.getFromGroup(); 
  }

  addHospitalTitle = true;
  editHospitalTitle;
  partnerId: number;
  partnerType: number = CommonConstants.PARTNER_HOSPITAL_TYPE;
  submitted = false;
  category:any[];
  categoryType:any[];
  groups: any[];
  certifications: any[];
  qualityCertifications: any[];

  @ViewChild(AddDepartmentComponent, { static: true }) hospDepartment: AddDepartmentComponent;
  @ViewChild(AddContactComponent, { static: true }) hospContact: AddContactComponent;
  @ViewChild(AddAddressComponent, { static: true }) hospAddress: AddAddressComponent;
  @ViewChild(AddSpecialityComponent, { static: true }) hospSpeciality: AddSpecialityComponent;
  @ViewChild(AddSubSpecialityComponent, { static: true }) hospSubSpeciality: AddSubSpecialityComponent;
  @ViewChild(AddHyperSpecialityComponent, { static: true }) hospHyperSpeciality: AddHyperSpecialityComponent;
  @ViewChildren(IntlTelNumberComponent) phoneNos: QueryList<IntlTelNumberComponent>
  ngOnInit() {
    this.loadMasterData();
    this.hosp.upload = null;
  }

  /**
   * To get form controls
   */
  get f() { return this.hospitalForm.controls; }

  loadMasterData() {
    this.masterService.getOrganisms().subscribe(response => {
      if (response && response['result']) {
        this.organisms = response['result'];
      }
    })

    this.masterService.getCategory().subscribe(response => {
      if (response && response['result']) {
        this.category =response['result'].filter(category => category.partnerType == this.partnerType);
      }
    })

    this.masterService.getCategoryType().subscribe(response => {
      if (response && response['result']) {
        this.categoryType  =response['result'].filter(type => type.partnerType == this.partnerType);
      }
    })

    this.masterService.getLegalForm().subscribe(response => {
      if (response && response['result']) {
        this.legalForms = response['result'];
      }
    })

    this.masterService.getGroup().subscribe(response => {
      if (response && response['result']) {
        this.groups = response['result'];
      }
    })
    this.masterService.getCertification().subscribe(response => {
      if (response && response['result']) {
        this.certifications = response['result'];
      }
    })
    this.masterService.getAgmntQualtiy().subscribe(response => {
      if (response && response['result']) {
        this.qualityCertifications = response['result'];
      }
    })
    this.masterService.getDepartments().subscribe(response => {
      if (response && response['result']) {
        this.departments = response['result'];
      }
    })
    this.masterService.getSpecialities().subscribe(response => {
      if (response && response['result']) {
        this.specialities = response['result'];
      }
    })

    this.masterService.getSubSpecialities().subscribe(response => {
      if (response && response['result']) {
        this.subSpecialities = response['result'];
      }
      })
      
      this.masterService.getHyperSpecialities().subscribe(response => {
        if (response && response['result']) {
          this.hyperSpecialities = response['result'];
        }
      })
      this.masterService.getAddressTypes().subscribe(response => {
        if (response['code'] == 'S0000') {
          this.addressTypeList = response['result'];
        }
      });
      this.masterService.getCountry().subscribe(response => {
        if (response && response['result']) {
          this.countries = response['result'];
  
        }
      })
  }

  saveHospital() {
    this.submitted = true;
    if (this.hospitalForm.invalid) {
      return;
    }
    if (this.hosp) {
      this.hospitalForm.patchValue({ staRecCode: this.f.staRecCode.value ? 'A' : 'I'});
      let jsonData=this.hospitalForm.value;
    this.phoneNos.forEach(phone => {
      jsonData[phone.type]=phone.setPhoneNumberfrmInternation();
    })
      this.loaderService.display(true);
      this.hospitalService.saveHospital(jsonData).subscribe(res => {
        this.loaderService.display(false);
        if (res['result']) {
          this.hospitalForm.patchValue({ hospiId: res['result'] });
          //  this.hosp.hospiId = res['result'];
        //  this.toastrService.success(res['message'], 'Success');
          swal.fire("Success", res['message'], 'success');
        } else {
          swal.fire("Error", res['message'], 'error');
          //this.toastrService.error(res['message'], 'Error');

        }
      },
        error => {
          this.loaderService.display(false);
        })
    }
  }

  /**
  * Declare form group
  *  
  */
  private getFromGroup() {
    this.hospitalForm = this.formBuilder.group({
      'hospiId': new FormControl(),
      'orgsmId': ['', Validators.required],
      'compaVaEmail': ['', Validators.email],
      'compVaHomepage': new FormControl(),
      'compaVaMobilePhone1': new FormControl(),
      'compaVaMobilePhone2': new FormControl(),
      'compaVaName': new FormControl(),
      'compaVaNameEn': ['', Validators.required],
      'compaNuNumberEmployees': new FormControl(),
      'compaVaVatRegistrationNo': new FormControl(),
      'compaVaWorkFax': new FormControl(),
      'compaVaWorkPhone': new FormControl(),
      'leforId': new FormControl(),
      'admntId': new FormControl(),
      'certiId': new FormControl(),
      'paCatId': new FormControl(),
      'pcTypId': new FormControl(),
      'paGrpId': new FormControl(),
      'hospiBlProposeFormation': [false],
      'hospiBlProposeInternship': [false],
      'upload': new FormControl(),
      'nationalId': new FormControl(),
      'code': new FormControl(),
      'staRecCode': [true]
    })
  }
reset(){
  this.hospitalForm.reset();
}
loadHospitalById(hospiId) {
  this.loaderService.display(true);
  this.hospitalService.getHospitalsById(hospiId).subscribe(res => {
    if (res['code'] == 'S0000') {
      let response = res['result'];
      this.hospitalForm.patchValue({
        hospiId: response["hospiId"],
        orgsmId: response["orgsmId"],
        compaVaEmail: response["compaVaEmail"],
        compVaHomepage: response["compVaHomepage"],
       // compaVaMobilePhone1: response["compaVaMobilePhone1"],
       // compaVaMobilePhone2: response["compaVaMobilePhone2"],
        compaVaName: response["compaVaName"],
        compaVaNameEn: response["compaVaNameEn"],
        compaNuNumberEmployees: response["compaNuNumberEmployees"],
        compaVaVatRegistrationNo: response["compaVaVatRegistrationNo"],
       // compaVaWorkFax: response["compaVaWorkFax"],
       // compaVaWorkPhone: response["compaVaWorkPhone"],
        leforId: response["leforId"],
        admntId: response["admntId"],
        certiId: response["certiId"],
        paCatId: response["paCatId"],
        pcTypId: response["pcTypId"],
        paGrpId: response["paGrpId"],
        hospiBlProposeFormation: response["hospiBlProposeFormation"],
        hospiBlProposeInternship: response["hospiBlProposeInternship"],
        nationalId: response["nationalId"],
        code: response["code"],
        upload: response["upload"],
        staRecCode: response["staRecCode"] === 'A' ? true : false
      });

      response.hospAddressList = response.hospAddressList.map(item => ({
        ...item,
        addressType: item.typeId ? this.addressTypeList.find(obj => +obj.typeId === +item.typeId).description: null,
        townName: item.townId ? this.towns.find(town => town.townId === item.townId).townDescEn : null,
        countryName: item.cotryId ? this.countries.find(country => country.cotryId === item.cotryId).cotryDescEn : null
      }));
      response.hospSpecialityList = response.hospSpecialityList.map(item => ({
        ...item,
        deptName: item.deptmId ? this.departments.find(obj => +obj.deptmId === +item.deptmId).deptmNameEn : null,
        spltyName: item.spltyId ? this.specialities.find(obj => +obj.spltyId === +item.spltyId).spltyDescEn : null
      }));
      response.hospSubSpecialityList = response.hospSubSpecialityList.map(item => ({
        ...item,
        ssptyName: item.ssptyId ? this.subSpecialities.find(obj => +obj.ssptyId === +item.ssptyId).ssptyDescEn: null
      }));
      response.hospHyperSpecialityList = response.hospHyperSpecialityList.map(item => ({
        ...item,
        hsptyName: item.hsptyId ? this.hyperSpecialities.find(obj => +obj.hsptyId === +item.hsptyId).hsptyDescEn: null
      }));
      this.hospDepartment.departmentList = JSON.parse(JSON.stringify(response.hospDepartmentList));
      this.sharedService.setOrganismDepartment(this.hospDepartment.departmentList);
      this.hospContact.employeeList = JSON.parse(JSON.stringify(response.hospEmployeeList));
      this.hospAddress.addressList = JSON.parse(JSON.stringify(response.hospAddressList));
      this.hospSpeciality.specList = JSON.parse(JSON.stringify(response.hospSpecialityList));
      this.hospSubSpeciality.subSpecList = JSON.parse(JSON.stringify(response.hospSubSpecialityList));
      this.hospHyperSpeciality.hyperSpecList = JSON.parse(JSON.stringify(response.hospHyperSpecialityList));
      this.phoneNos.forEach(phone => {
        phone.phone=phone.getInternationPhoneFormat(response[phone.type]);
    })
    }
    this.loaderService.display(false);
  },
  error => {
    this.loaderService.display(false);
  })
}
onChangeOrganism(event){
  if(event && event.cotryId){
    let country  =this.countries.filter(type => type.cotryId == event.cotryId);
    this.phoneNos.forEach(phone => {
      phone.selectedCountry=country[0].cotryCode;
   })
  }else{
    this.phoneNos.forEach(phone => {
      phone.selectedCountry=CountryISO.France;
   })
  }
}

}
